import React from 'react'

function WebsitePricing() {
  return (
    <div>
      <h1>Pricing</h1>
    </div>
  )
}

export default WebsitePricing
